import React from 'react';
import { connect } from 'react-redux';
import { SMARTPHONE } from '@/constants';
import SymbolSideMenu from './Symbol';

const SymbolSideMenuContainer = (props) => <SymbolSideMenu {...props} />

const mapStateToProps = state => ({
  sectionsSelection: state.core.sectionsSelection,
  shieldsSelection: state.core.shieldsSelection,
  mode: state.core.mode,
  targetDevice: state.core.targetDevice,
});

const mapDispatchToProps = dispatch => ({});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    mode,
    sectionsSelection,
    shieldsSelection,
    ...restStateProps
  } = stateProps;

  const {
    horizontalAlignment,
    verticalAlignment
  } = ownProps;

  const props = {
    ...restStateProps,
    ...dispatchProps,
    ...ownProps,
    isAllowedApplying: !!Object.keys(sectionsSelection).length,
    isSmartPhone: stateProps.targetDevice === SMARTPHONE,
    horizontalAlignment: horizontalAlignment,
    verticalAlignment: verticalAlignment,
  };

  return props;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SymbolSideMenuContainer);